/**
 * @file
 * Provide a methods for the maintenance page.
 */

(function ($, Drupal) {
  /**
   * Implement a modal to show the maintenance imprint
   */
  Drupal.behaviors.maintenanceImpressum = {
    attach: function attach(context) {
      once('awMaintenanceImpressum', '.js-maintenance-impressum-modal', context).forEach(function(currentElement) {
        currentElement.addEventListener('click', function() {
          let $impressum = $('.js-maintenance-impressum').clone(false);
          // Create modal
          $impressum.createModal(Drupal.t('Impressum'));
        });
      });
    }
  };
})(jQuery, Drupal);

